module.exports = __webpack_public_path__ + "static/media/winter.742c30c3.png";